import React, { useCallback, useEffect } from 'react';
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useReactFlow,
  Node,
  Edge,
  Connection,
  NodeChange,
  EdgeChange,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { CustomNode } from './customNode';
import ColorSymbol from './colorSymbolPallete';

interface WorkflowCanvasProps {
  nodes: Node[];
  edges: Edge[];
  onNodesChange: (changes: NodeChange[]) => void;
  onEdgesChange: (changes: EdgeChange[]) => void;
  onConnect: (connection: Connection) => void;
  onNodeClick: (event: React.MouseEvent, node: Node) => void;
  onEdgeClick?: (event: React.MouseEvent, edge: Edge) => void;
  onNodeDragStop?: (event: React.MouseEvent, node: Node) => void;
}

const nodeTypes = {
  customNode: CustomNode,
};

const WorkflowCanvas: React.FC<WorkflowCanvasProps> = ({nodes,edges,onNodesChange,onEdgesChange,onConnect,onNodeClick,onEdgeClick,onNodeDragStop}) => {
  const { fitView } = useReactFlow();

  useEffect(() => {
    if (nodes.length > 0) {
      fitView({ padding: 0.6 });
    }
  }, [nodes, fitView]);


  return (
    <div style={{ width: "100%", height: "100%", position: "relative", overflow: "hidden",touchAction: "none", }}>
      <ColorSymbol />
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onNodeClick={onNodeClick}
        onEdgeClick={onEdgeClick}
        nodeTypes={nodeTypes}
        fitView
        panOnScroll={false}         // ✅ prevents panning on two-finger scroll
        zoomOnScroll={false}        // ✅ prevents zoom on two-finger scroll
        zoomOnPinch={false}         // ✅ prevents zoom on pinch gesture
        panOnDrag={true}            // ✅ you can still drag with mouse
        preventScrolling={true}     // ✅ prevents parent container from scrolling
        minZoom={1}                 // ✅ optional: fix zoom level
        maxZoom={1}
        onNodeDragStop={onNodeDragStop}
      >
        <Controls showInteractive={false}/>
        <Background gap={8} color="#333" />
      </ReactFlow>
    </div>
  );
};

export default WorkflowCanvas;
